import { useTranslation } from 'react-i18next';
import { Button } from '@c2fo/liquidity';
import { TechnicalDifficultyIcon } from '@c2fo/liquidity/icons';
import NoDataState from './NoDataState';

const ErrorLoadingMarkets = () => {
  const { t } = useTranslation();

  return (
    <div className="rounded-xl bg-white p-4 shadow-md">
      <div className="bg-gray-50 p-10">
        <NoDataState
          icon={<TechnicalDifficultyIcon className="h-24 w-24" />}
          message={t('core.errorLoadingMarketsDescription')}
          action={
            <Button size="sm" variant="ancillary" onClick={() => window.location.reload()}>
              {t('core.refresh')}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default ErrorLoadingMarkets;
